import React from "react";

const TextfieldGroup = props => (
  <div className={`textfield-group ${props.isStreet ? "textfield-group--street" : ""}`}>
    {props.children}
  </div>
);

export default TextfieldGroup;
